module.exports = __webpack_public_path__ + "img/layers-button-active.838cb753.svg";